import { Record } from 'immutable';

export class Period extends Record<{
  min: Date | null,
  max: Date | null,
}>({
  min: null,
  max: null,
}) {}

interface ISerializedPeriod {
  min: string | null;
  max: string | null;
}

export const PeriodMarshaller = {
  deserialize: ({ min, max }: ISerializedPeriod) => new Period({
    min: typeof min === 'string' ? new Date(min) : null,
    max: typeof max === 'string' ? new Date(max) : null,
  }),
  serialize: (period: Period): ISerializedPeriod => period.toJSON(),
};

const EPOCH = new Date(0);

export class BoundedPeriod extends Record<{
  min: Date,
  max: Date,
}>({
  min: EPOCH,
  max: EPOCH,
}) {}

export const BoundedPeriodMarshaller = {
  deserialize: ({ min, max }: ISerializedPeriod) => {
    if (typeof min !== 'string' || typeof max !== 'string') {
      throw new Error(`Expected period to be bounded: (${min}, ${max})`);
    }

    return new BoundedPeriod({
      min: new Date(min),
      max: new Date(max),
    });
  },
  serialize: (period: BoundedPeriod): ISerializedPeriod => period.toJSON(),
};
